module.exports = __webpack_public_path__ + "static/media/alert-circle-white.83d2c3d9.svg";